import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Col, Input, Label, Row } from "reactstrap";
import PageSubHeader from "../../../../components/Layouts/PageSubHeader";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import sidebar from "../../utils/sidebar";
import CustomSelect from "../../../../components/Forms/CustomSelect";
import FixedSave from "../../../../components/Actions/FixedSave";
import { toast } from "react-toastify";
import { post } from "../../../../utils/helpers/api";

function CreateAttendancePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [saveLoading, setSaveLoading] = useState(false);
  const [attendanceData, setAttendanceData] = useState({
    employee: '',
    employee_id: '',
    attendance_date: new Date().toISOString().split('T')[0],
    check_in_time: '',
    check_out_time: '',
    status: ''
  });
  const [saveDisabled, setSaveDisabled] = useState(true);

  useEffect(() => {
    if(attendanceData.status === 'absent' && attendanceData.employee_id && attendanceData.attendance_date) {
      setSaveDisabled(false);
    } else {
      if(attendanceData.employee_id && attendanceData.attendance_date && attendanceData.check_in_time && attendanceData.check_out_time && attendanceData.status) {
        setSaveDisabled(false);
      } else {
        setSaveDisabled(true);
      }
    }
  }, [attendanceData]);

  const toTimeWithSeconds = time => {
    if (!time) return time;
    // <input type="time"> returns "HH:mm"; backend expects "HH:mm:ss"
    return time.split(':').length === 2 ? `${time}:00` : time;
  };

  const saveAttendance = async () => {
    setSaveLoading(true);
    const data = await post('/hr/attendance/store', {
      ...attendanceData,
      check_in_time: toTimeWithSeconds(attendanceData.check_in_time),
      check_out_time: toTimeWithSeconds(attendanceData.check_out_time),
    });
    if (data.success) {
      navigate('/hr/attendance');
    } else {
      toast.error(data.message || t('common.somethingWentWrong'));
    }
    setSaveLoading(false);
  };

  return(
    <SidebarLayout sidebar={sidebar}>
      <div className="page-with-subheader">
        <PageSubHeader
          breadcrumb={['Attendance', t('common.new') + ' Attendance']}
          onBack={() => navigate('/hr/attendance')}
        />
        <div className="subheader-page-content scrollable">
          <Row>
            <Col md="6" className="mb-3">
              <Label>Employee </Label>
              <CustomSelect
                value={attendanceData.employee || null}
                onChange={selected => setAttendanceData({ ...attendanceData, employee: selected ? selected.label : '', employee_id: selected ? selected.value : null })}
                module="hr/employees"
                placeholder={t('common.search')}
                createLink="/hr/employees/create"
              />
            </Col>
          </Row>
          <Row>
            <Col md="6" className="mb-3">
              <Label>Status</Label>
              <Input type="select" value={attendanceData.status} onChange={e => setAttendanceData({ ...attendanceData, status: e.target.value })}>
                <option value="">Select Status</option>
                <option value="present">Present</option>
                <option value="absent">Absent</option>
                <option value="leave">Leave</option>
              </Input>
            </Col>
          </Row>
          <Row>
            <Col md="6" className="mb-3">
              <Label>Attendance Date</Label>
              <Input
                type="date"
                className="form-control"
                value={attendanceData.attendance_date}
                onChange={e => setAttendanceData({ ...attendanceData, attendance_date: e.target.value })}
              />
            </Col>
          </Row>
          <Row>
            <Col md="6" className="mb-3">
              <Label>Check In Time</Label>
              <Input
                type="time"
                className="form-control"
                value={attendanceData.check_in_time}
                onChange={e => setAttendanceData({ ...attendanceData, check_in_time: e.target.value })}
              />
            </Col>
            <Col md="6" className="mb-3">
              <Label>Check Out Time</Label>
              <Input
                type="time"
                className="form-control"
                value={attendanceData.check_out_time}
                onChange={e => setAttendanceData({ ...attendanceData, check_out_time: e.target.value })}
              />
            </Col>
          </Row>
          <Row>
            <Col md="6" className="mb-3">
              <Label>Total Hours</Label>
              <Input
                type="number"
                min="0"
                step="1"
                className="form-control"
                value={attendanceData.check_in_time && attendanceData.check_out_time ? ((new Date(`1970-01-01T${attendanceData.check_out_time}`) - new Date(`1970-01-01T${attendanceData.check_in_time}`)) / 36e5).toFixed(2) : ''}
                readOnly
              />
            </Col>
          </Row>
        </div>
      </div>

      <FixedSave
        loading={saveLoading} 
        disabled={saveLoading || saveDisabled} 
        onSave={saveAttendance} 
      />
    </SidebarLayout>
  );
}

export default CreateAttendancePage;